export default __webpack_public_path__ + "static/media/Employees_Quick Dash with calculator.4dbfec41.pdf";